import { addFollow, FollowButton, withFollow } from '@eb/follow-organizer-ebui';
import { ngettext } from '@eb/i18n';
import React, { useContext } from 'react';
import { EnvContext, UserContext } from '../context';
import { Organizer } from '../types';

interface FollowOrganizerWidgetProps {
    gaSettings: object;
    gaCategory: string;
    organizers: Organizer[];
    isAuthenticated: boolean;
}

const EnhancedFollowButton = withFollow(FollowButton);
const FollowOrganizerWidget: React.FunctionComponent<FollowOrganizerWidgetProps> = (
    props,
) => {
    return (
        <EnhancedFollowButton
            isOnlyButton={true}
            organizerId={props.organizers[0]}
            renderFollowCount={(followCount: string) => {
                return (
                    <div className="eds-l-pad-top-4 follow-organizer__follow-count">
                        {ngettext(
                            '%(followCount)s follower',
                            '%(followCount)s followers',
                            parseInt(followCount),
                            { followCount },
                        )}
                    </div>
                );
            }}
        />
    );
};

interface FollowOrganizerProps {
    organizer: Organizer;
}

const EnhancedFollowOrganizerWidget = addFollow(FollowOrganizerWidget);
export const FollowOrganizer: React.SFC<FollowOrganizerProps> = (props) => {
    const { isAuthenticated } = useContext(UserContext);
    const { gaSettings } = useContext(EnvContext);

    return (
        <EnhancedFollowOrganizerWidget
            isAuthenticated={isAuthenticated}
            gaSettings={gaSettings}
            gaCategory={'organizer'}
            organizers={[props.organizer.id]}
        />
    );
};
